import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { AutoDirectComponent } from './auto-direct.component';
import { AutoDirectSummaryComponent } from './auto-direct-summary.component';
import { AutoDirectSettingsComponent } from './auto-direct-settings.component';
import { TableModule } from 'primeng';

const routes: Routes = [
  { path: '', component: AutoDirectComponent, data: { title: 'AutoDirect' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AutoDirectRoutingModule {}

@NgModule({
  imports: [
    AutoDirectRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TableModule,
  ],
  declarations: [AutoDirectSettingsComponent, AutoDirectSummaryComponent, AutoDirectComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AutoDirectModule {}
